module.exports = __webpack_public_path__ + "static/media/minus.9fbf8ec1.svg";